import { render, staticRenderFns } from "./DocumentFooter.vue?vue&type=template&id=a4260c5e&scoped=true&"
import script from "./DocumentFooter.vue?vue&type=script&lang=ts&"
export * from "./DocumentFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentFooter.vue?vue&type=style&index=0&id=a4260c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4260c5e",
  null
  
)

export default component.exports